export const fishingClubIntro = {
  heading: "1858 – 2025",
  subheading: "Vereinsgeschichte – Die Geschichte des ältesten Angelvereins Deutschlands",
  introText: `Liebe Angelfreunde und Leser unserer Vereinschronik,
bevor Sie sich in den Inhalt der Chronik vertiefen, gestatten Sie uns bitte einige einleitende Worte zur geschichtlichen Entwicklung von Vereinen in Deutschland.
Die ersten Vereinsgründungen allgemeiner Art – etwa Schützen-, Gesangs- oder Frauenvereine – fanden zu Beginn des 19. Jahrhunderts statt. Bei Fischzüchtern, Fischern und Anglern hingegen entstanden erste Vereine erst ab der Mitte des 19. Jahrhunderts.
So gründete sich am 16. November 1855 in München der „Fischer-Club München“, bestehend aus Fischzüchtern und Fischern. 1873 entwickelte er sich zum „Bayerischen Fischerei-Verein“, dem 1889 die Anerkennung als offizieller Verein verliehen wurde.
In Berlin formierte sich 1858 ein Anglerverein, der am 8. März 1866 in das Vereinsregister eingetragen wurde und damit den Status eines anerkannten Vereins erhielt. Er nannte sich fortan „Central-Verein der Angelfreunde 1866 zu Berlin“. 
Dabei handelt es sich um unseren heutigen Verein, der nach über 160 Jahren Geschichte den Namen „Angelfreunde 1866 e.V.“ trägt. Er gilt als erster Anglerverein Deutschlands, und sein Gründungsdatum markiert zugleich den Beginn des organisierten Angelns in unserem Land.
Weitere Einzelheiten zur Entwicklung unseres Vereins können Sie in der folgenden Zeitleiste nachlesen – oder im YouTube-Vortrag von Heinz Haase anhören.`
};

export const fishingClubData = [
  {
    title: "1858",
    content: `
      Bei einem fidelen Angeln an der Spree entstand unter den Teilnehmern der Gedanke einen Verein zu gründen. 
      Diese Idee ließ die Angler nicht mehr los und kurze Zeit später einigten sich anlässlich der Einweihung 
      der Mühlenberger Anglervilla in Stralau die Mühlenberger und Stralauer Angler einen Angler-Verein zu gründen. 
      Die Gründungsversammlung selbst fand bei Mundt in der Köpenicker Straße 100 statt.
    `,
  },
  {
    title: "1863",
    content: `
      In den Jahren zwischen 1858 und 1863 nahm die Anzahl der Mitglieder ständig zu. 
      Als sie schließlich 1863 sprunghaft von 30 auf 80 anwuchs, wurde das bis dahin genutzte Lokal zu klein 
      und man zog in das Lokal von Streich in der neuen Friedrichstraße 44 um.
    `,
  },
  {
    title: "1866",
    content: `
      Der Vorstand des Vereins hatte inzwischen Statuten und alle zu der offiziellen Vereinsgründung 
      erforderlichen Unterlagen ausgearbeitet und der Polizeibehörde vorgelegt. Sie wurden genehmigt und 
      somit wurde der Verein am 8. März 1866 unter der Policen-Nummer 148 in das Berliner Vereinsregister eingetragen. 
      Er gab sich den Namen „Central-Verein der Angelfreunde 1866 zu Berlin.“ 
      Von diesem Zeitpunkt an beging unser Verein jährlich im Monat März ein so genanntes Stiftungsfest.
    `,
  },
  {
    title: "1867",
    content: `
      Heimstatt für die Angler unseres Vereins war der Rummelsburger See. In einer der Versammlungen 
      wurde aber darüber Klage geführt, dass der See so verkrautet ist, dass Angler und der Kahn gefährdet seien. 
      Ab wann der See vom Verein gepachtet wurde, ist bis dahin noch nicht erkennbar.
    `,
  },
  {
    title: "1869",
    content: `
      Im Protokoll vom 18. März übten die Mitglieder Kritik am Lokal. Das Lokal sei verschmutzt, die Stühle kaum 
      zum Sitzen zu gebrauchen und überhaupt sei das ganze Lokal höchst mangelhaft. Der Wirt versprach daraufhin, 
      das Lokal vollständig restaurieren zu lassen. 
      Am 2. Dezember legte der 1. Vorsitzende, nachdem er den Verein 11 Jahre lang geleitet hatte, 
      seine Funktion nieder und es kam zur Neuwahl.
    `,
  },
  {
    title: "1870",
    content: `
      Innerhalb des Vereins bildete sich ein Chor und eine Lotteriegemeinschaft. Wegen des Krautes im 
      Rummelsburger See wurde im Berliner Abgeordnetenhaus vorgesprochen. In der Versammlung am 3. Januar 
      wertete man die Fangergebnisse der vergangenen drei Jahre aus. Dabei wurde festgestellt, dass in den 
      Jahren 1867 und 1868 die Fangergebnisse gut waren. Dagegen wurde 1869 schlecht gefangen.
      Der Schriftführer des Vereins eröffnet mit einem Taler einen „Fahnenfonds.“ In der Folgezeit bestickten die 
      Frauen und Mädchen des Vereins den Fahnenstoff.
    `,
  },
  {
    title: "1875",
    content: `
      Nach jahrelanger und mühevoller Kleinarbeit war dann die Fahne fertig. Anlässlich des Stiftungsfestes 
      am 8. März übergaben die Frauen und Mädchen dem Verein am 8. März die fertige Fahne. 
      (Diese Fahne befindet sich noch heute in unserem Besitz, worauf wir besonders stolz sind. 
      Sie hat Seltenheitswert und wird als historisch wertvolles Kulturgut eingestuft.)
    `,
  },
  {
    title: "1883",
    content: `
      In der Mitgliederversammlung am 6. Februar machte ein Mitglied den Vorschlag, dem Sieger des 
      traditionellen „Königsangeln“ zusätzlich ein Geschenk zu überreichen und dazu 15,00 Mark aus der 
      Vereinskasse zu verwenden. Es kam zu einer heftigen Debatte in der man sich nicht einigen konnte und 
      so wurde schließlich der Vorschlag abgelehnt.
    `,
  },
  {
    title: "1884",
    content: `
      Auf der am 21. Februar stattgefundenen Mitgliederversammlung wurde nach Durcharbeitung aller Paragrafen 
      ein neues Statut und eine überarbeitete Geschäftsordnung mit großer Mehrheit angenommen.
    `,
  },
  {
    title: "1887",
    content: `
      Im April stellte sich heraus, dass „ … die Fischerei des Rummelsburger Sees“ wieder zu verpachten sei. 
      Der jährliche Pachtzins sollte 54,00 Mark betragen. Die Mitglieder kamen zu der Auffassung, diesen 
      Pachtzins aufbringen zu können. Sie beschlossen, den Rummelsburger See zu pachten.
    `,
  },
  {
    title: "1888",
    content: `
      An der Vereinsfahne wurde eine erste Reparatur notwendig. Dazu eingeleitete Maßnahmen ergaben, dass 
      für eine saubere Ausführung der Reparatur 200,00 Mark notwendig seien. Das erschien den Mitgliedern zu teuer. 
      Am 4. Oktober wurde deshalb eine dreiköpfige Kommission gebildet, die dazu weitere Erkundigungen einziehen sollte.
    `,
    attachment: {
      url: "/Chronik/Protokoll_1888.pdf",
      title: "Protokoll der Vereinsversammlung am 14. Oktober 1888, u.a. zur Reparatur der Vereinsfahne",
    }
  }
  ,
  {
    title: "1889",
    content: `
      Es gelang dem Verein, den Rummelsburger See für das Jahr 1889 wieder zu pachten.
    `,
  },
  {
    title: "1890",
    content: `
      Am 6. Februar wurde der Beitritt zum Deutschen Fischerei-Verein beschlossen.
    `,
  },
  {
    title: "1891",
    content: `
      Das 25jährige Stiftungsfest fand am 7. März im Neuen Clubhaus in der Kommandantenstraße 72 (heute Kreuzberg) statt. 
      Es feierten 123 Teilnehmer, davon 40 Mitglieder, 32 Mitgliedsfrauen und 51 Gäste. 
      Die Frauen und Mädchen stifteten aus diesem Anlass ein Fahnenband.
      (Es befindet sich noch heute an unserer Fahne.)
      Auf diesem Fest kamen erste Gedanken zur Vereinigung aller deutschen Angler zur Sprache. 
      Der Vorsitzende nahm dieses zum Anlass, darauf ein „Hoch!“ auszusprechen, was von den Gästen freudig erwidert wurde.
    `,
  },
  {
    title: "1893",
    content: `
      Durch eine Vermittlung des Kammerherren und Fischzüchters Max von dem Borne in Berneuchen, wurde der 
      „Central-Verein der Angelfreunde 1866 zu Berlin“ Mitglied im „Fischerei-Verein der Provinz Brandenburg.“
    `,
  },
  {
    title: "1894",
    content: `
      Weitere Kontakte zu Max von dem Borne führten dazu, dass sein früherer Fischmeister Herrguth, 
      der jetzt an der Versuchsanstalt am Müggelsee tätig war, am 8. Februar im Verein ein Vortrag über die 
      künstliche Fischzucht hielt. Herrguth versprach der Versammlung, den vom Verein gepachteten Rummelsburger 
      See untersuchen zu lassen, um daraus Schlussfolgerungen für einen Fischbesatz zu ziehen.
    `,
  },
  {
    title: "1895",
    content: `
      Auf der Versammlung am 5. Dezember wurde die Anfertigung und Anschaffung eines neuen moderneren Vereinsabzeichens beschlossen. 
      Es sollte Flaggenformat mit den Farben grün, weiß rot und im Mittelfeld einen Fisch haben.
    `,
  },
  {
    title: "1896",
    content: `
      Im Februar wurde das neue Abzeichen an die Mitglieder des Vereins verteilt. 
      Im Oktober wurde von zwei Delegierten berichtet, dass der vom Dresdener Angler-Club beabsichtigte 
      Angler-Kongreß zur Gründung eines Verbandes Deutscher Sportangler wegen mangelnder Beteiligung gescheitert ist.
    `,
  },
  {
    title: "1898",
    content: `
      Im Februar berichtete der Vorsitzende, dass er an einer Aussprache im „Fischer-Club“ teilgenommen habe. 
      Dort wurde gefordert, das Angeln ganz zu verbieten. Er selbst nahm das zum Anlass, mit scharfen Worten dagegen 
      zu sprechen und die Interessen der Angler wahrzunehmen. Der 1. Vorsitzende, Kamerad Wessely, gab nach 12 Jahren 
      die Funktion des Vorsitzenden ab. Neuer 1. Vorsitzender wurde Kamerad Schmidt.
      Für die Fahne wurde mit der Summe von 800,00 Mark eine Versicherung abgeschlossen.
    `,
  },
  {
    title: "1899",
    content: `
      Im Januar erschien der Redakteur der Deutschen Fischerei-Zeitung, Herr Carl Paeske in der Versammlung 
      und meldete seine Mitgliedschaft im Verein an.
      Im Februar und im April wurden drei für den Verein bedeutende und einflussreiche Männer Mitglied: 
      Herr Paeske als Zeitungsverleger, Herr Timm als Buchdruckereibesitzer und Herr Dr. med. Horst Brehm als Arzt 
      (Sohn des Zoologen Alfred Brehm).
    `,
  },
  {
    title: "1900",
    content: `
      Es ist das Jahr des verstärkten Einflusses unseres Vereins auf die Gründung einer Vereinigung aller deutscher Angler.
      Die weiteren Ereignisse des Jahres im Zeitraffer:

      - **8. Februar:** Diskussion über den Entwurf zur Änderung des Fischereigesetzes. Ausgehend von dieser Versammlung 
        sollten durch Säulenanschlag alle Berliner Angler-Vereine mobil gemacht werden, um gegen die Gesetzesänderung 
        Front zu machen und die Gründung eines Deutschen Angler-Bundes zu fordern.

      - **8. März:** Es erschienen zur Versammlung Vertreter vom „Ältesten Stralauer AV“, vom AV „Plötze“, 
        vom AV „Freundschaft“ und von der „Anglerkolonie Grünau.“ 
        Unter dem Motto „Nichtswürdig ist jeder Sportangler, der seine Ehre nicht verteidigt“ wurde zum gemeinsamen 
        Kampf gegen die Änderung des Fischereigesetzes aufgerufen.

      - **5. April:** In dieser Versammlung unseres Vereins wurde ein Komitee gewählt, das den Kampf gegen die Änderung 
        des Fischereigesetzes bündeln und zentral führen sollte. Dieses Komitee verfasste einen „Aufruf zur Begründung eines 
        allgemeinen Deutschen Angler-Bundes.“ 
        Der Angelgerätefabrikant Fritz Ziegenspeck wurde an diesem Tag Mitglied im Verein.

      - **26. April:** Es wurde extra eine Generalversammlung einberufen. Dr. Horst Brehm gab die inzwischen ausgearbeiteten 
        Statuten des Deutschen Angler-Bundes bekannt. Die Gründung war für den 31. Mai 1900 vorgesehen. Unser Verein 
        beschloss, dem Bund beizutreten.

      - **31. Mai:** Gründung des „Deutschen Angler-Bundes“ (DAB). Kam. Dr. Brehm wurde I. Vizepräsident und Kam. Carl Paeske Generalsekretär.

      - **4. Oktober:** Kam. Paeske gab im Verein einen Bericht über die Gründung des DAB, war erfreut über den regen Zuspruch 
        und gab an, dass der Bund inzwischen 1800 Mitglieder hat. Er gab weiter bekannt, dass ab dem 15. Oktober der Bund eine 
        eigene Zeitung mit dem Titel „Deutsche Angler-Zeitung“ herausgeben wird.

      - **6. Dezember:** Kam. Dr. Horst Brehm berichtete in der Mitgliederversammlung des Vereins über die Fortschritte 
        innerhalb des DAB.
    `,
    attachment: {
      url: "/Chronik/Protokoll_1900.pdf",
      title: "Protokoll der Generalversammlung am 26. April 1900, u.a. zur Gründung des Deutschen Anglerbundes",
    }
  },
  {
    title: "1903",
    content: `
      In der Generalversammlung am 1. März legte der bisherige 1. Vorsitzende Kam. Schmidt den Vorsitz nieder. 
      Als neuer 1. Vorsitzender wurde Kam. Schiebler I gewählt.
      Zum Bundesfest, das vom 23. bis 25. Mai in Berlin stattfand, wurden 3 Kameraden des Vereins delegiert. 
      Sie führten unsere Fahne mit, die dort präsentiert wurde.
    `,
  },
  {
    title: "1905",
    content: `
      Der DAB wollte die Vereine damit beauflagen, je Mitglied eine Anglerzeitung zu abonnieren. 
      In der Mai-Versammlung wurde darüber heftig diskutiert. Manche Mitglieder sträubten sich dagegen und schlugen 
      aufgrund dieser Tatsache sogar den Austritt des Vereins aus dem Bund vor. Die Mitglieder Dr. Horst Brehm und Carl Paeske 
      sprachen dagegen, und Dr. Brehm erläuterte in einem Vortrag die Zusammenhänge, die diese Maßnahme erforderte, 
      und bat noch einmal gründlich darüber nachzudenken. Es kam zu einer Abstimmung. 
      6 Mitglieder waren für und 12 gegen einen Austritt aus dem DAB.
    `,
  },
  {
    title: "1906",
    content: `
      In der Februar-Versammlung wurde das Festkomitee zur Vorbereitung des 40-jährigen Stiftungsfestes mit einer Tombola gewählt. 
      Der genaue Termin ist nicht bekannt. In der Versammlung am 7. März wurde berichtet, dass das Stiftungsfest gut und gemütlich verlaufen sei. 
      Es nahmen insgesamt 190 Personen teil. Vom Präsidenten des DAB und gleichzeitigem Mitglied unseres Vereins, Kam. Dr. Horst Brehm, 
      kam eine Glückwunschdepesche, die beim Fest verlesen wurde.
    `,
  },
  {
    title: "1907",
    content: `
      In der Januar-Versammlung legte Kam. Schiebler I nach 3 Jahren Tätigkeit als 1. Vorsitzender sein Amt nieder. 
      Neu gewählt wurde mit 18 von 23 Stimmen Kam. Engelien.
      Im Februar wurde der Beschluss gefasst, die internationale Sportausstellung, die am 20. April in Berlin stattfand, 
      mit Ausstellungsobjekten zu unterstützen und bei der Gestaltung selbst mit Hand anzulegen.
      Im März wurde das Vereinsmitglied Carl Paeske aus dem Verein ausgeschlossen, da er für das Jahr 1906 keinen Beitrag gezahlt hatte 
      und auch auf eine Mahnung nicht reagierte.
      Der Schriftführer brachte zum Ausdruck, dass das Protokollbuch nunmehr 25 Jahre alt ist. Da nur noch wenige Seiten zur Verfügung stehen, 
      stellte er den Antrag, ein neues Buch anzulegen. Dem Antrag wurde zugestimmt.
    `,
  },
  {
    title: "1908–1931",
    content: `
      Die Beteiligung unseres Vereins am Kampf um mehr Rechte der Angler und die Gründung des Deutschen Angler-Bundes (DAB) lagen nun schon wieder 8 Jahre zurück. 
      Durch verschiedene Festlegungen und Maßnahmen wurde der Einfluss des DAB bis in unsere Vereinstätigkeit spürbar, insbesondere durch den Bezug der Deutschen Angler-Zeitung 
      und die in den Versammlungen zum Inhalt der Zeitschrift geführten Diskussionen.
      
      Aus den Protokollen wird deutlich, dass der Rummelsburger See weiterhin Heimstatt unseres Vereins war und dass in allen Jahren ein regelmäßiges und von Frohsinn geprägtes 
      Vereinsleben stattfand. Getragen wurde es besonders durch:
        - Stiftungsfeste im März (Jahrestag der Gründung),
        - Frühstücksfeste im Mai,
        - Königsangeln im Juni, meist an der Liebesinsel, wo der „Angel-König“ und der „Angel-Ritter“ gekürt wurden. 
          Danach gab es ein gemütliches Sommerfest in einer Lokalität.
        - Dampferfahrten durch die Berliner Gewässer, Kinderfeste, Weihnachtsfeiern und Berichte über Angelergebnisse.
      
      Während des 1. Weltkrieges waren Geldspenden zur Linderung der Schrecken und Schmerzen des Krieges bei allen Versammlungen ein Thema, welche an das Rote Kreuz überwiesen wurden.
      
      Am 1. Januar 1921 hatte der Verein 30 Mitglieder. Zu den Höhepunkten zählte das 60-jährige Stiftungsfest am 27. März 1926.
      
      Interessante Ereignisse aus den Protokollen:
        - Mai 1920: Ein Antrag, die Aalschnüre zukünftig mit 100 statt 50 Haken zu bestücken, wurde „mit großer Majorität“ abgelehnt.
        - Mitglieder wurden nach 40-jähriger treuer Mitgliedschaft zu Ehrenmitgliedern ernannt.
        - Im August 1930 nahmen Mitglieder am „Stralauer Fischzug“ teil.
    `,
  },
  {
    title: "1932–1957",
    content: `
      Dieser Zeitabschnitt war für unseren Verein besonders wechselvoll, geprägt von unterschiedlichen gesellschaftspolitischen Systemen. Der Verein gehörte folgenden Dachverbänden an:
        - Bis 1933: „Deutscher Anglerbund“.
        - 1933–1945: „Reichsverband Deutscher Sportangler“.
        - 1945–1954: Ohne Zugehörigkeit zu einem Dachverband.
        - Ab 1954: „Deutscher Anglerverband“, dem unser Verein auch heute noch angehört.
      
      Bemerkenswert ist, dass der Verein nicht Mitglied im „Arbeiter-Angler-Bund Deutschlands“ wurde, vermutlich aufgrund der mehrheitlichen Mittelstandszugehörigkeit der Mitglieder.
      
      Von 1932 bis 1944 wurde in der Zeitschrift „Der Deutsche Sportangler“ regelmäßig über unseren Verein berichtet. Eine Notiz aus der Märzausgabe 1936 lautet:
        „70-jähriges Stiftungsfest. Am 3. März feiert der älteste deutsche Anglerverein, der ‚Zentralverein der Angelfreunde 1866 Berlin Stralau’, 
        sein 70-jähriges Stiftungsfest im Restaurant Tübbecke, Alt Stralau. Gäste sind herzlich willkommen.“
      
      Weitere Ereignisse aus unseren Protokollbüchern:
        - Am 19. Januar 1938 wurde Sportfreund Alwin Vetter Seeaufseher. Später spielte er als Vereinsvorsitzender eine bedeutende Rolle.
        - Unentschuldigtes Fehlen bei Mitgliederversammlungen wurde mit 0,50 Reichsmark bestraft. Die Einziehung erfolgte bei der nächsten Beitragskassierung.
        - Im Mai 1939 fand das Anangeln mit 15 Kähnen und 25 Anglern am Waisenhaus-Ufer statt. Der Verein hatte damals 39 Mitglieder.
    `,
  },
  {
    title: "1958–1989",
    content: `
      Über diese Zeitperiode hinweg existierte unsere Anglergemeinschaft weiterhin durchgehend unter dem bereits genannten Namen 
      „DAV Ortsgruppe Friedrichshain“. Da die hohe Mitgliederzahl unserer sogenannten „Grundorganisation“ über mehrere Jahre hinweg anhielt, 
      fanden unsere Mitgliederversammlungen fast durchgängig im Kulturhaus des Reichsbahn-Ausbesserungswerkes (RAW) „Franz Stenzer“ 
      in der Revaler Straße 99 statt.

      Große Bedeutung für das Leben unserer Anglergemeinschaft hatte jetzt inzwischen das bereits 1956 erworbene 1000 qm große Grundstück 
      „Alte Ziegelei“ am Seddinsee in Gosen mit einem ausrangierten Wohnboot bekommen. Wir nannten es liebevoll „Unsere Johanna“ und bauten 
      es besonders in den Jahren zwischen 1956 und 1958 in mühevoller Kleinarbeit zum Anglerheim aus. Grundstück und Anglerheim wurden von 
      da an bis zum heutigen Tage zum Mittelpunkt unseres gesamten Vereinslebens überhaupt.

      Im Jahr 1970 traf unsere Ortsgruppe ein harter Schlag. Der Sportfreund Alwin Vetter, von 1940 bis 1967 Vorsitzender unseres Vereins, 
      Mitbegründer des DAV und Träger der DAV-Ehrennadel in Gold, verstarb am 20. März 1970. Sein erfolgreiches Wirken über fast drei Jahrzehnte 
      hinweg und seine Verdienste werden uns stets in ehrenhafter Erinnerung bleiben.

      Als er 1967 den Vorsitz abgab, entstand zunächst ein Vakuum. Niemand wollte die entstandene Lücke im Vorstand einer solch großen Ortsgruppe – 
      zu Spitzenzeiten ca. 600 Mitglieder – schließen und Verantwortung übernehmen. Schließlich gelang es, den Sportfreund Günther Bühler für diese 
      Funktion zu gewinnen. Er unterstützte besonders die Jugendarbeit sowie die damals vom DAV angestrebten und auch geförderten Wettkämpfe in allen 
      Disziplinen. Ende 1971 gab er die Leitung aus gesundheitlichen Gründen ab. Nachfolger in der Funktion des Vorsitzenden wurde der Sportfreund 
      Bruno Grützmacher.

          Im Jahr 1986 gab es innerhalb unseres Vereinslebens zwei besondere Höhepunkte.

    Am 8. März 1986 feierten wir unser 120-jähriges Vereinsjubiläum. Die Feier fand in der Clubgaststätte „Solidarität“ 
    in der Alfred-Jung-Straße 14 statt und wurde unter Beteiligung zahlreicher Ehrengäste, der Presse und vieler Mitglieder 
    zu einem würdigen und unvergesslichen Ereignis. Vorsitzender war zu diesem Zeitpunkt, als Nachfolger von Sportfreund 
    Bruno Grützmacher, der Sportfreund Helmut Staudte. Eine beeindruckende Ausstellung mit unserer Vereinsfahne und bedeutenden 
    Exponaten erinnerte an unsere traditionsreiche Geschichte. Diese Ausstellung wurde anschließend vom 10. bis 13. März 1986 
    im Club der Werktätigen „Sonia Horn“ unter dem Motto „120 Jahre Angelsport in Friedrichshain“ öffentlich gezeigt.

    Der zweite Höhepunkt war die Vorstandswahl am 14. Oktober 1986. Aufgrund gesundheitlicher Gründe legte Sportfreund 
    Helmut Staudte den Vorsitz nieder, und sein Stellvertreter, Sportfreund Jürgen Matthes, wurde zum neuen Vorsitzenden gewählt. 
    Der Vorstand unserer großen Angler-Ortsgruppe hatte immense Aufgaben zu bewältigen – nicht nur vereinsintern, sondern auch 
    aufgrund zahlreicher Vorgaben der DAV-Geschäftsstellen und des Bezirksfachausschusses. Entsprechend bestand der Vorstand 
    zu dieser Zeit aus 16 Mitgliedern – eine aus heutiger Sicht einmalige Zusammensetzung.

    Ebenso beeindruckend war die sportliche Beteiligung unserer Mitglieder. Bei nahezu allen Wettkämpfen wie Friedfischangeln, 
    Spinnangeln, Flugangeln und Dreikampf (Jugend, Frauen, Männer) waren unsere Delegierten erfolgreich. Unsere Ortsgruppe 
    wurde 1969, 1970 und 1971 dreimal in Folge Bezirksmeister im Friedfischangeln – ein bisher unerreichter Erfolg. Beim 
    DDR-offenen Meeresangeln mit 650 Teilnehmern belegten wir den 1. und 4. Platz.

    Auch die Jugendarbeit war in dieser Zeit sehr aktiv. Ein Beispiel ist das Trainingslager vom 1. bis 15. Mai 1987 in Gosen. 
    Dort wurden Kinder und Jugendliche durch theoretische und praktische Unterweisungen, Angeln, Wandern und Bastelarbeiten 
    in unser naturverbundenes Hobby eingeführt. Einer der Teilnehmer war der damals 10-jährige Sportfreund Denny Linke, 
    der heute als engagiertes Mitglied aktiv unser Vereinsleben mitgestaltet.
  
    `,
  },
  {
    title: "1990–2007",
    content: `
    Unmittelbar nach der Wende begann für unsere Anglergemeinschaft ein Prozess der völligen Umgliederung. 
    Aus der DAV-Ortsgruppe musste ein gemeinnützig anerkannter Verein auf Basis des Bürgerlichen Gesetzbuches entstehen.

    Eine wichtige Entscheidungshilfe war der IX. Verbandstag des DAV am 23. Februar 1991 in Pätz (Brandenburg), 
    bei dem die Delegierten mehrheitlich für den eigenständigen Fortbestand des DAV stimmten. Damit wurde auch 
    eine neue Satzung beschlossen, die die Identität des DAV e.V. mit dem DAV der DDR bekräftigte. 
    Für unsere Anglergemeinschaft stand fest: Der DAV war und bleibt die Basis unserer Vereinsarbeit.

    Für den Vorstand begann eine anspruchsvolle Zeit: Eine Satzung musste ausgearbeitet und beim Amtsgericht 
    Charlottenburg eingereicht werden, außerdem die Gemeinnützigkeit beim Finanzamt beantragt werden. 
    Eine zusätzliche Hürde war die ursprüngliche Vereinsbezeichnung „Central-Verein der Angelfreunde 1866“, 
    die so nicht anerkannt wurde. Der neue Name lautete daher fortan: „Angelfreunde 1866“. 
    Der Verein trat damit offiziell die Rechtsnachfolge der DAV-Ortsgruppe Friedrichshain an.

    Am 9. März 1991 feierten wir unser 125-jähriges Jubiläum in der Clubgaststätte „Solidarität“. 
    Die Musikgruppe „Floer“ sorgte für gute Stimmung, und ein Rückblick in unsere Vereinsgeschichte 
    zeigte die tiefe Verbundenheit mit unseren Traditionen.

    Die Wahlversammlung am 5. November 1991 markierte einen weiteren bedeutenden Meilenstein:
    - Der Vorstand wurde neu gewählt,
    - die überarbeitete Satzung beschlossen,
    - Ordnungen für die zukünftige Vereinsarbeit verabschiedet.

    Sportfreund Jürgen Matthes wurde als Vorsitzender bestätigt, ebenso Sportfreund Helmut Staudte als Stellvertreter. 
    Neu gewählt wurde Sportfreund Gerhard Hempel als 1. Kassierer. Dieses Team führte den Verein sicher durch eine 
    oft schwierige Übergangsphase.

    Im Laufe der Jahre wechselten Vorsitzende und Vorstandsmitglieder entsprechend der satzungsgemäßen Wahlperioden 
    oder aus persönlichen Gründen. Auf der neuen rechtlichen Grundlage, durch die fortlaufende Nutzung unserer 
    Heimanlage und dank eines vielfältigen Vereinslebens – stets basierend auf jährlich neu erarbeiteten 
    Veranstaltungsplänen – setzen wir die Traditionen unseres 1866 gegründeten Vereins bis heute in Ehren fort.
      Im September 2005 bestätigten langjährige historische Recherchen endgültig, dass unser Verein, gegründet am 8. März 1866, 
    der älteste Angler-Verein Deutschlands ist. Der Beweis gelang durch den Vergleich mit der im Internet veröffentlichten 
    Chronik des heutigen Bayerischen Fischerei-Vereins in München, der erst 1889 ins Vereinsregister eingetragen wurde.

    In den Jahren zwischen 1991 und 2007 erlebte unser Vereinsleben weitere bedeutende Höhepunkte:

    - Am 10. März 2001 fand im Sportcasino „Eiche“ in Köpenick die Festveranstaltung zum 135-jährigen Vereinsjubiläum mit zahlreichen Ehrengästen statt.
    - Im November 2005 beschloss die Mitgliederversammlung eine Spendenaktion zur Restauration unserer 1875 gestifteten Vereinsfahne. 
      Am 30. Oktober 2006 war das Ziel von 5.000 Euro erreicht, sodass die Fahne im Dezember 2007 restauriert werden konnte.
    - Am 11. März 2006 feierten wir unser 140-jähriges Bestehen im Kongress Hotel Berlin-Rahnsdorf. Eine Ausstellung machte die Gäste mit 
      der Geschichte unseres Vereins vertraut. Unter den Ehrengästen war auch der DAV-Präsident Bernd Mikulin aus Dresden.
    - Zur Feier erschien eine Dokumentation mit dem Titel: „1866 bis 2006 – 140 Jahre Tradition mit Zukunft.“
    - Über 30 Jahre freundschaftliche Beziehungen zum Anglerverein „Frühauf“ Dessau und ab 2005 neu geknüpfte Verbindungen 
      zum AV „Sonntagsfreude“ Berlin am Großen Wannsee.
    - Präsentation unseres Vereins in einer eigenen Homepage und in der Ausstellung „Schuppen-Scheren-Schalentiere – Berliner Fischereigeschichte(n)“ im Stadtmuseum Berlin.
    - Der unermüdliche Einsatz unserer Mitglieder zur Pflege und Erhaltung unserer Heimanlage und der „Johanna“, die nach wie vor das Zentrum unseres Vereinslebens bildet.
    - Die beliebten Familiennachmittage mit Spiel und Spaß, die jährlich stattfinden.

    Zum Abschluss des Jahres 2007 können wir mit Stolz sagen: Es ist uns gelungen, die Gedanken und Ziele unserer Gründer 
    lebendig zu halten und erfolgreich weiterzuführen. Ausdruck dessen ist die seit dem 140-jährigen Jubiläum formulierte These, 
    die sinnbildlich für unsere Vereinsarbeit steht.
  `,
  },
  {
    title: "2008–2015",
    content: `
    Unser Motto „Tradition mit Zukunft“ prägt auch weiterhin unser Vereinsleben und bildet die Grundlage unserer gemeinschaftlichen Arbeit.

    In diesem Zeitraum können wir mit Stolz auf drei besondere Ereignisse zurückblicken:

    - **Restauration unserer Vereinsfahne:** Die 1875 von den Frauen und Mädchen des Vereins gestiftete Fahne wurde 2007 sachgemäß restauriert. 
      Seit dem 18. April 2008 ist sie in einer Vitrine in der Berliner Bundesgeschäftsstelle des Deutschen Angelfischerverbandes DAFV e.V. untergebracht. Die aufwendige und kostenintensive Restaurierung wurde durch eine erfolgreiche Spendenaktion ermöglicht – allen Spendern gilt unser herzlicher Dank.
    
    <img src="/Chronik/2008_Vereinsfahne.jpg" alt="2008 Vereinsfahne" class="my-4 rounded-lg shadow-md" />

    - **Ehrung durch das Bezirksamt Friedrichshain-Kreuzberg:** Seit dem Jahr 2008 werden jährlich zwei Mitglieder unseres Vereins 
      für ihr ehrenamtliches Engagement mit einer Urkunde und einem Warengutschein durch den Stadtrat ausgezeichnet. 
      Diese Ehrungen sind ein Zeichen der Anerkennung durch den Stadtbezirk und unterstreichen die Bedeutung 
      unserer Vereinsarbeit für die lokale Gemeinschaft.

    - **Neuwahl des Vereinsvorsitzenden:** In diesem Zeitraum kam es außerdem zur Neuwahl unseres Vereinsvorsitzenden, 
      was einen weiteren wichtigen Meilenstein in der Vereinsgeschichte darstellt.

    Unser Verein bleibt durch seine aktive Rolle im Stadtbezirk Berlin-Friedrichshain weiterhin sichtbar und geschätzt.
      Folgende Höhepunkte prägten unser Vereinsleben in den Jahren 2008 bis 2015:

    - Auf der Berliner Bootsmesse 2009 präsentierte sich unser Verein als ältester deutscher Anglerverein mit eigens angefertigten Bildtafeln und zog großes Interesse auf sich.
    - Am 28. Juni 2009 veranstaltete der DAV-Bezirksverband Berlin-Friedrichshain ein Jugendbootsangeln auf unserem Vereinsgelände in Gosen.
    - Unsere enge Zusammenarbeit mit dem DAV-Landesverband Berlin und dem Jugendzentrum in Pankow fördert intensiv die Jugendarbeit.
    - Bei der Vorstandswahl am 11. November 2010 verabschiedeten wir unseren langjährigen Vorsitzenden Heinz Haase, der aus Altersgründen zurücktrat und Ehrenmitglied wurde. Neuer Vorsitzender ist seitdem Denny Linke.
    - Zum 145-jährigen Vereinsbestehen feierten wir am 5. März 2011 in der Bundesgeschäftsstelle des DAV e.V. Berlin, begleitet von zahlreichen Ehrengästen und Presse. Die Festrede hielt DAV-Präsident Günter Markstein.
        
    <img src="/Chronik/145_Jahre_Jubiläum.jpg" alt="145 Jahre Jubiläum" class="my-4 rounded-lg shadow-md" />

    - Die Pflege unserer Heimanlage hat einen hohen Stellenwert. Mehrfach jährlich organisieren wir Arbeitseinsätze, um unser Vereinsgrundstück in Schuss zu halten.
    - Die aktive Rolle der Frauen in unserem Verein wurde 2012 durch einen Artikel in der Zeitschrift „Frau von heute“ unter der Überschrift „Wo Frauen große Hechte ködern“ gewürdigt.
    - Seit 2013 pflegen wir enge Verbindungen zur Gemeinde Gosen, sind regelmäßig beim Dorffest präsent und unterstützen aktiv beim Festzeltaufbau.
    - Die Feuerwehr Neu-Zittau half uns nach einem Sturm bei der Beseitigung von Astbruch an unseren Erlen.
    - 2014 erhielt unser Hausboot „Johanna“ einen neuen Anstrich, weitere Arbeitseinsätze verbesserten unser Grundstück; 2015 wurde unter anderem der Zaun erneuert. 
      Ein herzlicher Dank geht an alle engagierten Mitglieder, die auch außerhalb der offiziellen Einsätze mitgeholfen haben.

    Diese Zusammenfassung zeigt, dass es unserer Anglergemeinschaft gelungen ist, die Gründergedanken zu bewahren und erfolgreich weiterzuführen.
  `,
  },
  {
    title: "2016",
    content: `
    150. Gründungsjubiläum unseres Vereins am 8. März 2016.  
    Mit Stolz und im Bewusstsein der festen Verwurzelung im Kreis der vielen aktiven Angelvereine und -verbände
    danken wir allen, die gemeinsam mit uns das 150. Gründungsjubiläum würdigten.  
    Die Feierstunde im Präsidium des Deutschen Angelfischerverbandes, wo wir vor unserer dort dauerhaft präsentierten Vereinsfahne
    mit der höchsten Auszeichnung geehrt wurden, bildete den Höhepunkt der Feierlichkeiten.  

    Wir werden auch künftig gemäß unseres Mottos *"Tradition mit Zukunft"* unsere gemeinsame Leidenschaft Angeln
    pflegen und in Einklang mit dem Schutz unserer Umwelt weiterentwickeln.  
    Petri Heil!

    Unser Verein erhält anläßlich seines 150. Gründungsjubiläums die Ehrenplakette des DAFV im Rahmen
einer würdigen Feierstunde vor unserer dort dauerhaft präsentierten historischen Vereinsfahne.
  `,
    image: "/Chronik/150_Jahre_Jubiläum.jpg",
    attachment: {
      url: "/Chronik/Jubiläum.pdf",
      title: "Ausgabe unserer Verbandszeitschrift 'Der Märkische Angler' 1 - 2016",
    }
  },
  {
    title: "2017-2019",
    content: `Im Oktober 2017 verursachte das Sturmtief Xavier auf dem Vereinsgrundstück in Gosen erhebliche Schäden. Betroffen waren unter anderem der Steg, der Vereinsschuppen sowie der Zaun. Dank des tatkräftigen Einsatzes unserer Vereinsmitglieder konnten diese Schäden jedoch zeitnah repariert werden.

    Ungeachtet dieser Ereignisse blieb das Vereinsleben weiterhin von der gemeinsamen Sportausübung und der Erholung in der Natur bestimmt. Einen großen Stellenwert nahmen auch in diesen Jahren die Pflege und Instandhaltung des Vereinsgrundstücks ein. Neben den regelmäßigen Arbeiten erforderte dies jedes Jahr erneut viel Fleiß, Einsatzbereitschaft und Zusammenhalt – nicht nur während der traditionellen „Arbeitseinsätze“ im Frühjahr und Herbst, sondern auch darüber hinaus.

    Dazu gehörte zum Beispiel 2018 auch die fachgerechte Sanierung des Daches unseres Hausbootes „Johanna“. Diese Maßnahme trug wesentlich zum Erhalt des Bootes und zur langfristigen Nutzung bei.

    Ebenfalls im Oktober 2018 fanden turnusgemäß die Wahlen des Vereinsvorstands statt. Wir freuten uns sehr, dass Denny L. erneut zum Vereinsvorsitzenden gewählt wurde. Ihm sowie allen weiteren gewählten Vorstandsmitgliedern sprachen wir unsere herzlichen Glückwünsche und unseren Dank für die Übernahme dieser verantwortungsvollen Aufgaben aus.

    `,
  },
    {
    title: "2020-2022",
    content: `Die Jahre 2020 bis 2022 standen ganz im Zeichen der Corona-Pandemie und ihrer weitreichenden Auswirkungen auf das Vereinsleben. Aufgrund der behördlichen Auflagen konnte im Februar 2021 keine Jahreshauptversammlung stattfinden. Auch geplante Arbeitseinsätze sowie das Sommerfest mussten pandemiebedingt abgesagt werden. Zeitweise war sogar das Angeln vollständig untersagt, was für viele Sportsfreunde eine besonders einschneidende Einschränkung darstellte.

    Im Jahr 2021 wurde zudem eine langjährige Tradition beendet: Da die Fangzahlen beim „Stralsund-Angeln“ über mehrere Jahre hinweg stetig zurückgegangen waren und viele Teilnehmer kaum noch Fische fingen, fand diese Veranstaltung letztmalig statt.

    Trotz der schwierigen Rahmenbedingungen wurden notwendige Arbeiten durchgeführt. So erneuerte Sportsfreund Michael K. im Juni 2021 im Auftrag des Vereins den Stegbelag des Hauptstegs und leistete damit einen wichtigen Beitrag zur Sicherheit und Nutzbarkeit der Anlage.

    Ein erfreulicher Lichtblick war das Jahr 2022: Endlich konnte am 02.07.2022 wieder ein Sommerfest auf dem Vereinsgrundstück stattfinden. Bei bestem Wetter genossen alle Anwesenden das tolle Sommerwetter, die Gemeinschaft und die entspannte Atmosphäre bei Spiel und Spaß.

    Im August 2022 jährte sich zudem das Freundschaftsangeln mit den „Dessauern“ zum 50. Mal. Anlässlich dieses besonderen Jubiläums führte Sportsfreund Mario M. am Abend einen Dia Film mit historischen Aufnahmen vor. Für alle Beteiligten war es eine große Freude, ehemalige Sportsfreunde, frühere Vereinsmitglieder und sogar sich selbst in jungen Jahren wiederzusehen.

    Gegen Ende des Jahres 2022 wurde der Verein jedoch erneut vor große Herausforderungen gestellt: Denny L. gab bekannt, dass er nach zwölf Jahren aus persönlichen Gründen den Posten des Vereinsvorsitzenden abgeben möchte. Da sich keine Interessenten für dieses Amt fanden, konnten die geplanten Neuwahlen im November 2022 nicht stattfinden. Die Situation war sehr ernst und ließ zeitweise sogar die Auflösung des Vereins befürchten.

    `,
  },
      {
    title: "2023-2025",
    content: `Am 15.01.2023 trafen sich auf Einladung vom Vereinsmitglied Jolina K. engagierte Mitglieder, denen der Erhalt des Vereins besonders am Herzen lag, im Restaurant „Solino“ in Gosen. In diesem offenen und konstruktiven Austausch wurde die kritische Lage ausführlich besprochen und gemeinsam nach Lösungen gesucht. Dieses Treffen bildete die entscheidende Grundlage für das Fortbestehen des Vereins.

    Die Neuwahl des Vorstands konnte schließlich am 22.06.2023 erfolgreich durchgeführt werden. Paul M. wurde zum neuen Vereinsvorsitzenden gewählt, Michael K. übernahm das Amt des 1. stellvertretenden Vorsitzenden. Marion B. wurde zur 1. Kassiererin sowie zur 2. stellvertretenden Vorsitzenden gewählt. Dem ehemaligen Vorsitzenden Denny L. gilt an dieser Stelle ein besonderer Dank für seine langjährigen und engagierten Dienste zum Wohle des Vereins.

    Ein weiterer Höhepunkt war die Jahreshauptversammlung am 08.02.2024, zu der der Präsident des Anglerverbandes Berlin-Friedrichshain e.V. (AVBF), Ralf B., als Gast begrüßt werden konnte. In diesem feierlichen Rahmen wurde Sportsfreund Kurt D., der leider nicht anwesend sein konnte, für seine 70-jährige Vereinsmitgliedschaft mit der Ehrennadel in Gold ausgezeichnet. Zusätzlich erhielt er von Präsident Ralf B. die Medaille „65 Jahre Anglerverband Berlin-Friedrichshain“. Darüber hinaus wurden vier neue Mitglieder herzlich begrüßt und dem Verein vorgestellt.

    Im Jahr 2025 rückte das Thema Sicherheit auf dem Vereinsgrundstück in den Mittelpunkt. Dringend notwendige Baumfällarbeiten wurden, nach Einholen der erforderlichen Genehmigungen, fachgerecht durchgeführt. Ebenso mussten am Hauptsteg die Standrohre ersetzt werden, da die Standsicherheit nahezu überall nicht mehr gegeben war. Nach Erteilung der Genehmigung durch das zuständige Amt konnten auch diese Arbeiten sach- und fachgerecht umgesetzt werden.

    Diese Maßnahmen stellten eine erhebliche finanzielle Belastung für den Verein dar und konnten nur durch den Einsatz vorhandener Rücklagen finanziert werden.

    Ein besonders großer Meilenstein war die Verlängerung des Pachtvertrages um weitere 20 Jahre. Sie gibt dem Verein langfristige Planungssicherheit und wurde von allen Mitgliedern mit großer Freude aufgenommen.

    Die allgemein gestiegenen Kosten in nahezu allen Bereichen machten es notwendig, die Mitgliedsbeiträge ab 2026 zu erhöhen, nachdem diese über viele Jahre hinweg stabil gehalten werden konnten.

    Wie geplant ging Ende 2025 zudem die neue Vereinswebseite online, die von Ben P. erstellt wurde. Der schlichte und übersichtliche Aufbau erleichtert insbesondere potenziellen neuen Mitgliedern die Kontaktaufnahme und stellt einen wichtigen Schritt in Richtung moderner Vereinsarbeit dar.

    `,
  }


];
